import * as React from "react";
import { Notification } from "baseui/notification";
import { mergeOverrides } from "baseui";

import { ParagraphXSmall } from "../typography";
import LightBulb from "../icons/LightBulb";
import Brain from "../icons/Brain";
import { Block } from "baseui/block";

export enum Kind {
  Assistance = "ASSISTANCE",
  Smarts = "SMARTS",
}

const INFO = {
  [Kind.Assistance]: {
    icon: LightBulb,
    backgroundColor: "backgroundLightAccent",
  },
  [Kind.Smarts]: {
    icon: Brain,
    backgroundColor: "backgroundLightAccent",
  },
};

/**
 * Callout component used to display info to help the user
 */
export function Callout({
  children,
  overrides: calloutOverrides,
  width,
  highlight,
  kind = Kind.Assistance,
  hideIcon = false,
  ...restProps
}: {
  children: React.ReactNode;
  overrides?: object;
  width?: string;
  highlight?: boolean;
  kind?: Kind;
  hideIcon?: boolean;
}) {
  const info = INFO[kind];
  const Icon = info.icon;
  const overrides = mergeOverrides(
    {
      InnerContainer: {
        style: {
          display: "flex",
          alignItems: "flex-start",
        },
      },
      Body: {
        style: ({ $theme }) => ({
          maxWidth: width,
          width: "auto",
          backgroundColor: "none",
        }),
      },
    },
    calloutOverrides
  );
  return (
    <Notification overrides={overrides} {...restProps}>
      {!hideIcon && (
        <Block
          width="50px"
          height="50px"
          marginRight="4px"
          backgroundColor={info.backgroundColor}
          display="flex"
          alignItems="center"
          justifyContent="center"
          overrides={{
            Block: {
              style: {
                borderRadius: "25px",
              },
            },
          }}
        >
          <Icon size={24} />
        </Block>
      )}
      <Block
        display="flex"
        alignItems="center"
        flex="1"
        padding={highlight ? "5px 24px" : "5px 8px"}
        minHeight="40px"
        marginTop="0"
        marginBottom="0"
        backgroundColor={highlight ? info.backgroundColor : "none"}
        overrides={{
          Block: {
            style: {
              borderRadius: "25px",
            },
          },
        }}
      >
        <ParagraphXSmall display="inline" {...(!highlight ? { margin: 0 } : {})}>
          {typeof children === "string"
            ? children.split("\n").map((line, index) => <div key={index}>{line}</div>)
            : children}
        </ParagraphXSmall>
      </Block>
    </Notification>
  );
}
